import React, { useCallback } from "react";
import PurchaseDocDetails from "../../_components/Purchasing/PurchaseDocDetails";
import {
    getPurchaseInvoiceById,
    updatePurchaseInvoice,
    createPurchaseInvoice,
    deletePurchaseInvoice,
} from "../../_services/purchase.service";
import { getActiveSupplierCompanyNames } from "../../_services/contact.service";
import { companyProfileService } from "../../_services/companyProfile.service";
import { fetchContactPersons, fetchSupplierDetails, usePurchaseInvoiceReferenceFields } from "./purchaseInvoiceShared";

const fetchDirectPI = (id) => getPurchaseInvoiceById(id).then(res => {
    if (res.piType !== "Direct") throw new Error("Not a Direct PI");
    return res;
});

const wrapCreate = (data) => createPurchaseInvoice({ ...data, piType: "Direct" });
const wrapUpdate = (id, data) => updatePurchaseInvoice(id, { ...data, piType: "Direct" });

export default function DirectPurchaseInvoiceDetails() {
    const fetchCompProfile = useCallback(() => companyProfileService.getProfile(), []);
    const { extraFields } = usePurchaseInvoiceReferenceFields({ piType: "Direct" });

    return (
        <PurchaseDocDetails
            docType="Direct Purchase Invoice"
            basePath="/finance/direct-purchase-invoices"
            fetchById={fetchDirectPI}
            updateItem={wrapUpdate}
            deleteItem={deletePurchaseInvoice}
            createItem={wrapCreate}
            fetchSupplierNames={getActiveSupplierCompanyNames}
            fetchContactPersons={fetchContactPersons}
            fetchSupplierDetails={fetchSupplierDetails}
            fetchCompanyProfile={fetchCompProfile}
            taxRate={0}
            searchable={false}
            searchSource="RM"
            extraFields={extraFields}
        />
    );
}
